import { useState } from "react";
import Image, { ImageProps } from "next/image";
import Loader from "./Loader";
import { NoImage } from "../../../public";

interface ImageWithLoaderProps extends Omit<ImageProps, "onLoad" | "onError"> {
    containerClassName?: string;
    loaderClassName?: string;
}

const ImageWithLoader = ({
    src,
    alt,
    className = "",
    containerClassName = "",
    loaderClassName = "",
    ...props
}: ImageWithLoaderProps) => {
    const [isImgLoading, setIsImgLoading] = useState(true);

    return (
        <div className={`relative ${containerClassName}`}>
            {isImgLoading && (
                <div className={`absolute inset-0 z-10 flex items-center justify-center ${loaderClassName}`}>
                    <Loader />
                </div>
            )}
            <Image
                src={src || NoImage}
                alt={alt}
                className={`${className} transition-opacity duration-300 ${isImgLoading ? "opacity-0" : "opacity-100"
                    }`}
                onLoad={() => setIsImgLoading(false)}
                onError={() => setIsImgLoading(false)}
                {...props}
            />
        </div>
    );
};

export default ImageWithLoader;
